import type {CourseApiModel as Course} from '@yourcoach/shared/api/course';
import type {MaterialApiModel as Material} from '@yourcoach/shared/api/material';
import type {FileApiModel} from '@yourcoach/shared/api/media/file';
import type {LinkApiModel as Link} from '@yourcoach/shared/api/media/link';
import type {EditionApiModel as Edition} from '@yourcoach/shared/api/program';

import {linkStore} from '@yourcoach/shared/api/media/link';
import {currentUserStore} from '@yourcoach/shared/api/user';
import {getUuid} from '@yourcoach/shared/utils/getUuid';

import type {Expanded as CourseExpanded} from '@src/modules/courses/utils';

export type ScheduleMaterial = Edition['materials'][0] & {
  files: (FileApiModel | null)[];
};

interface Expanded {
  course?: (Course & CourseExpanded) | null;
  files: (FileApiModel | null)[];
}

// TODO: Move to shared
export const materialIsFolder = (material: Material | ScheduleMaterial) =>
  (material.file_ids || []).length > 1;

// TODO: Move to shared
export const getMaterialFile = (
  material: (Material & Expanded) | ScheduleMaterial,
) => (material.files || [])[0];

// TODO: Move to shared
export const linksToMaterials = (
  links: (Link & {resource: FileApiModel})[],
) => {
  const promises: Promise<
    (Error & {isError: boolean}) | ScheduleMaterial | {emptyFolder: boolean}
  >[] = [];

  links.forEach(link => {
    if (link.type === 'folder') {
      const unfoldPromise = linkStore
        .unfold(link, {
          expand: {
            link: ['resource_id'],
          },
          query: [['type', '==', 'link']],
        })
        .then(
          // @ts-expect-error: TODO: Fix this
          (result: {
            _expanded: {[key: string]: FileApiModel};
            _items: (Link & {resource: FileApiModel})[];
          }) => {
            if (!result._items.length) {
              return Promise.resolve({
                emptyFolder: true,
              });
            }

            return Promise.resolve({
              coach_id: currentUserStore.user ? currentUserStore.user._id : '',
              day: 0,
              description: '',
              file_ids: result._items.map(item => item.resource_id),
              files: result._items.map(item =>
                item.resource_id ? result._expanded[item.resource_id] : null,
              ),
              time: 0,
              title:
                result._items.length === 1 ? result._items[0]!.name : link.name,
              uuid: getUuid(),
            });
          },
        )
        .catch((e: Error) => ({
          ...e,
          isError: true,
        }));

      promises.push(unfoldPromise);
    } else {
      const promise = Promise.resolve({
        coach_id: currentUserStore.user ? currentUserStore.user._id : '',
        day: 0,
        description: '',
        file_ids: link.resource_id ? [link.resource_id] : [],
        files: [link.resource],
        time: 0,
        title: link.name,
        uuid: getUuid(),
      });

      promises.push(promise);
    }
  });

  return promises;
};
